// extracted by mini-css-extract-plugin
export default {"readable_input_label":"styled_readable_input_label__ZSfA7","readable_input_copy_button":"styled_readable_input_copy_button__rxe9p","readable_input":"styled_readable_input__+eqh-"};